const AUTUMNLEAVES = {
  value: [
    {
      chorddata: {
        quality: "MINOR7",
        root: "A"
      },
      chordlength: 1
    },
    {
      chorddata: {
        quality: "DOMINANT7",
        root: "D"
      },
      chordlength: 1
    },
    {
      chorddata: {
        quality: "MAJOR7",
        root: "G"
      },
      chordlength: 1
    },
    {
      chorddata: {
        quality: "MAJOR7",
        root: "C"
      },
      chordlength: 1
    },
    {
      chorddata: {
        quality: "MINOR7FLAT5",
        root: "Gb"
      },
      chordlength: 1
    },
    {
      chorddata: {
        quality: "DOMINANT7",
        root: "B"
      },
      chordlength: 1
    },
    {
      chorddata: {
        quality: "MINOR7",
        root: "E"
      },
      chordlength: 2
    },
    {
      chorddata: {
        quality: "MINOR7",
        root: "A"
      },
      chordlength: 1
    },
    {
      chorddata: {
        quality: "DOMINANT7",
        root: "D"
      },
      chordlength: 1
    },
    {
      chorddata: {
        quality: "MAJOR7",
        root: "G"
      },
      chordlength: 1
    },
    {
      chorddata: {
        quality: "MAJOR7",
        root: "C"
      },
      chordlength: 1
    },
    {
      chorddata: {
        quality: "MINOR7FLAT5",
        root: "Gb"
      },
      chordlength: 1
    },
    {
      chorddata: {
        quality: "DOMINANT7",
        root: "B"
      },
      chordlength: 1
    },
    {
      chorddata: {
        quality: "MINOR7",
        root: "E"
      },
      chordlength: 2
    },
    {
      chorddata: {
        quality: "MINOR7FLAT5",
        root: "Gb"
      },
      chordlength: 1
    },
    {
      chorddata: {
        quality: "DOMINANT7",
        root: "B"
      },
      chordlength: 1
    },
    {
      chorddata: {
        quality: "MINOR7",
        root: "E"
      },
      chordlength: 2
    },
    {
      chorddata: {
        quality: "MINOR7",
        root: "A"
      },
      chordlength: 1
    },
    {
      chorddata: {
        quality: "DOMINANT7",
        root: "D"
      },
      chordlength: 1
    },
    {
      chorddata: {
        quality: "MAJOR7",
        root: "G"
      },
      chordlength: 2
    },
    {
      chorddata: {
        quality: "MINOR7FLAT5",
        root: "Gb"
      },
      chordlength: 1
    },
    {
      chorddata: {
        quality: "DOMINANT7",
        root: "B"
      },
      chordlength: 1
    },
    {
      chorddata: {
        quality: "MINOR7",
        root: "E"
      },
      chordlength: 2
    },
    {
      chorddata: {
        quality: "MINOR7FLAT5",
        root: "Gb"
      },
      chordlength: 1
    },
    {
      chorddata: {
        quality: "DOMINANT7",
        root: "B"
      },
      chordlength: 1
    },
    {
      chorddata: {
        quality: "MINOR7",
        root: "E"
      },
      chordlength: 2
    }
  ],
  label: "Autumn Leaves"
}



const RHYTHM = {
  value: [
    {
      chorddata: {
        quality: "MAJOR7",
        root: "Bb"
      },
      chordlength: 1
    },
    {
      chorddata: {
        quality: "DOMINANT7",
        root: "G"
      },
      chordlength: 1
    },
    {
      chorddata: {
        quality: "MINOR7",
        root: "C"
      },
      chordlength: 1
    },
    {
      chorddata: {
        quality: "DOMINANT7",
        root: "F"
      },
      chordlength: 1
    },
    {
      chorddata: {
        quality: "MAJOR7",
        root: "Bb"
      },
      chordlength: 1
    },
    {
      chorddata: {
        quality: "DOMINANT7",
        root: "G"
      },
      chordlength: 1
    },
    {
      chorddata: {
        quality: "DOMINANT7",
        root: "C"
      },
      chordlength: 1
    },
    {
      chorddata: {
        quality: "DOMINANT7",
        root: "F"
      },
      chordlength: 1
    },
    {
      chorddata: {
        quality: "MAJOR7",
        root: "Bb"
      },
      chordlength: 1
    },
    {
      chorddata: {
        quality: "DOMINANT7",
        root: "Bb"
      },
      chordlength: 1
    },
    {
      chorddata: {
        quality: "MAJOR7",
        root: "Eb"
      },
      chordlength: 1
    },
    {
      chorddata: {
        quality: "MINOR7",
        root: "Eb"
      },
      chordlength: 1
    },
    {
      chorddata: {
        quality: "MAJOR7",
        root: "Bb"
      },
      chordlength: 1
    },
    {
      chorddata: {
        quality: "MINOR7",
        root: "C"
      },
      chordlength: 1
    },
    {
      chorddata: {
        quality: "DOMINANT7",
        root: "F"
      },
      chordlength: 1
    },
    {
      chorddata: {
        quality: "MAJOR7",
        root: "Bb"
      },
      chordlength: 1
    },
    {
      chorddata: {
        quality: "DOMINANT7",
        root: "D"
      },
      chordlength: 2
    },
    {
      chorddata: {
        quality: "DOMINANT7",
        root: "D"
      },
      chordlength: 2
    },
    {
      chorddata: {
        quality: "DOMINANT7",
        root: "G"
      },
      chordlength: 2
    },
    {
      chorddata: {
        quality: "DOMINANT7",
        root: "G"
      },
      chordlength: 2
    },
    {
      chorddata: {
        quality: "DOMINANT7",
        root: "C"
      },
      chordlength: 2
    },
    {
      chorddata: {
        quality: "DOMINANT7",
        root: "C"
      },
      chordlength: 2
    },
    {
      chorddata: {
        quality: "DOMINANT7",
        root: "F"
      },
      chordlength: 2
    },
    {
      chorddata: {
        quality: "DOMINANT7",
        root: "F"
      },
      chordlength: 2
    },
    {
      chorddata: {
        quality: "MAJOR7",
        root: "Bb"
      },
      chordlength: 1
    },
    {
      chorddata: {
        quality: "DOMINANT7",
        root: "G"
      },
      chordlength: 1
    },
    {
      chorddata: {
        quality: "MINOR7",
        root: "C"
      },
      chordlength: 1
    },
    {
      chorddata: {
        quality: "DOMINANT7",
        root: "F"
      },
      chordlength: 1
    },
    {
      chorddata: {
        quality: "MAJOR7",
        root: "Bb"
      },
      chordlength: 1
    },
    {
      chorddata: {
        quality: "DOMINANT7",
        root: "G"
      },
      chordlength: 1
    },
    {
      chorddata: {
        quality: "DOMINANT7",
        root: "C"
      },
      chordlength: 1
    },
    {
      chorddata: {
        quality: "DOMINANT7",
        root: "F"
      },
      chordlength: 1
    },
    {
      chorddata: {
        quality: "MAJOR7",
        root: "Bb"
      },
      chordlength: 1
    },
    {
      chorddata: {
        quality: "DOMINANT7",
        root: "Bb"
      },
      chordlength: 1
    },
    {
      chorddata: {
        quality: "MAJOR7",
        root: "Eb"
      },
      chordlength: 1
    },
    {
      chorddata: {
        quality: "MINOR7",
        root: "Eb"
      },
      chordlength: 1
    },
    {
      chorddata: {
        quality: "MAJOR7",
        root: "Bb"
      },
      chordlength: 1
    },
    {
      chorddata: {
        quality: "MINOR7",
        root: "C"
      },
      chordlength: 1
    },
    {
      chorddata: {
        quality: "DOMINANT7",
        root: "F"
      },
      chordlength: 1
    },
    {
      chorddata: {
        quality: "MAJOR7",
        root: "Bb"
      },
      chordlength: 1
    },
  ],
  label: "I've Got Rhythm"
}


const ALLTHETHINGSYOUARE = {
  value: [
    {
      chorddata: {
        quality: "MINOR7",
        root: "F"
      },
      chordlength: 1
    },
    {
      chorddata: {
        quality: "MINOR7",
        root: "Bb"
      },
      chordlength: 1
    },
    {
      chorddata: {
        quality: "DOMINANT7",
        root: "Eb"
      },
      chordlength: 1
    },
    {
      chorddata: {
        quality: "MAJOR7",
        root: "Ab"
      },
      chordlength: 1
    },
    {
      chorddata: {
        quality: "MAJOR7",
        root: "Db"
      },
      chordlength: 1
    },
    {
      chorddata: {
        quality: "DOMINANT7",
        root: "G"
      },
      chordlength: 1
    },
    {
      chorddata: {
        quality: "MAJOR7",
        root: "C"
      },
      chordlength: 2
    },
    {
      chorddata: {
        quality: "MINOR7",
        root: "C"
      },
      chordlength: 1
    },
    {
      chorddata: {
        quality: "MINOR7",
        root: "F"
      },
      chordlength: 1
    },
    {
      chorddata: {
        quality: "DOMINANT7",
        root: "Bb"
      },
      chordlength: 1
    },
    {
      chorddata: {
        quality: "MAJOR7",
        root: "Eb"
      },
      chordlength: 1
    },
    {
      chorddata: {
        quality: "MAJOR7",
        root: "Ab"
      },
      chordlength: 1
    },
    {
      chorddata: {
        quality: "DOMINANT7",
        root: "D"
      },
      chordlength: 1
    },
    {
      chorddata: {
        quality: "MAJOR7",
        root: "G"
      },
      chordlength: 2
    },
    {
      chorddata: {
        quality: "MINOR7",
        root: "A"
      },
      chordlength: 1
    },
    {
      chorddata: {
        quality: "DOMINANT7",
        root: "D"
      },
      chordlength: 1
    },
    {
      chorddata: {
        quality: "MAJOR7",
        root: "G"
      },
      chordlength: 2
    },
    {
      chorddata: {
        quality: "MINOR7",
        root: "Gb"
      },
      chordlength: 1
    },
    {
      chorddata: {
        quality: "DOMINANT7",
        root: "B"
      },
      chordlength: 1
    },
    {
      chorddata: {
        quality: "MAJOR7",
        root: "E"
      },
      chordlength: 1
    },
    {
      chorddata: {
        quality: "DOMINANT7",
        root: "C"
      },
      chordlength: 1
    },
    {
      chorddata: {
        quality: "MINOR7",
        root: "F"
      },
      chordlength: 1
    },
    {
      chorddata: {
        quality: "MINOR7",
        root: "Bb"
      },
      chordlength: 1
    },
    {
      chorddata: {
        quality: "DOMINANT7",
        root: "Eb"
      },
      chordlength: 1
    },
    {
      chorddata: {
        quality: "MAJOR7",
        root: "Ab"
      },
      chordlength: 1
    },
    {
      chorddata: {
        quality: "MAJOR7",
        root: "Db"
      },
      chordlength: 1
    },
    {
      chorddata: {
        quality: "MINOR7",
        root: "Db"
      },
      chordlength: 1
    },
    {
      chorddata: {
        quality: "MINOR7",
        root: "C"
      },
      chordlength: 1
    },
    {
      chorddata: {
        quality: "DOMINANT7",
        root: "F"
      },
      chordlength: 1
    },
    {
      chorddata: {
        quality: "MINOR7",
        root: "Bb"
      },
      chordlength: 1
    },
    {
      chorddata: {
        quality: "DOMINANT7",
        root: "Eb"
      },
      chordlength: 1
    },
    {
      chorddata: {
        quality: "MAJOR7",
        root: "Ab"
      },
      chordlength: 2
    },
  ],
  label: "All The Things You Are"
}




const GIRLFROMIPANEMA = {
  value: [
    {
      chorddata: {
        quality: "MAJOR7",
        root: "F"
      },
      chordlength: 2
    },
    {
      chorddata: {
        quality: "DOMINANT7",
        root: "G"
      },
      chordlength: 2
    },
    {
      chorddata: {
        quality: "MINOR7",
        root: "G"
      },
      chordlength: 1
    },
    {
      chorddata: {
        quality: "DOMINANT7",
        root: "Gb"
      },
      chordlength: 1
    },
    {
      chorddata: {
        quality: "MAJOR7",
        root: "F"
      },
      chordlength: 1
    },
    {
      chorddata: {
        quality: "DOMINANT7",
        root: "Gb"
      },
      chordlength: 1
    },
    {
      chorddata: {
        quality: "MAJOR7",
        root: "F"
      },
      chordlength: 2
    },
    {
      chorddata: {
        quality: "DOMINANT7",
        root: "G"
      },
      chordlength: 2
    },
    {
      chorddata: {
        quality: "MINOR7",
        root: "G"
      },
      chordlength: 1
    },
    {
      chorddata: {
        quality: "DOMINANT7",
        root: "Gb"
      },
      chordlength: 1
    },
    {
      chorddata: {
        quality: "MAJOR7",
        root: "F"
      },
      chordlength: 2
    },
    {
      chorddata: {
        quality: "MAJOR7",
        root: "Gb"
      },
      chordlength: 2
    },
    {
      chorddata: {
        quality: "DOMINANT7",
        root: "B"
      },
      chordlength: 2
    },
    {
      chorddata: {
        quality: "MINOR7",
        root: "Gb"
      },
      chordlength: 2
    },
    {
      chorddata: {
        quality: "DOMINANT7",
        root: "D"
      },
      chordlength: 2
    },
    {
      chorddata: {
        quality: "MINOR7",
        root: "G"
      },
      chordlength: 2
    },
    {
      chorddata: {
        quality: "DOMINANT7",
        root: "Eb"
      },
      chordlength: 2
    },
    {
      chorddata: {
        quality: "MINOR7",
        root: "A"
      },
      chordlength: 1
    },
    {
      chorddata: {
        quality: "DOMINANT7",
        root: "D"
      },
      chordlength: 1
    },
    {
      chorddata: {
        quality: "MINOR7",
        root: "G"
      },
      chordlength: 1
    },
    {
      chorddata: {
        quality: "DOMINANT7",
        root: "C"
      },
      chordlength: 1
    },
    {
      chorddata: {
        quality: "MAJOR7",
        root: "F"
      },
      chordlength: 2
    },
    {
      chorddata: {
        quality: "DOMINANT7",
        root: "G"
      },
      chordlength: 2
    },
    {
      chorddata: {
        quality: "MINOR7",
        root: "G"
      },
      chordlength: 1
    },
    {
      chorddata: {
        quality: "DOMINANT7",
        root: "Gb"
      },
      chordlength: 1
    },
    {
      chorddata: {
        quality: "MAJOR7",
        root: "F"
      },
      chordlength: 2
    },

  ],
  label: "The Girl From Ipanema"
}

export const changes = [AUTUMNLEAVES, RHYTHM, ALLTHETHINGSYOUARE, GIRLFROMIPANEMA]